import { Button, Input, Modal, Row } from 'antd'
import './LoadOrderTemplate.style.less'
import { SearchOutlined } from '@ant-design/icons'
import { useQuery } from 'react-query'
import { getOrderTemplate } from '../../../Order.transform'
import { useState } from 'react'
import { debounce, orderBy } from 'lodash'
import cx from 'classnames'

interface Props {
  visible: boolean
  onClose: () => void
  onApply: (item) => void
}

function LoadOrderTemplate(props: Props) {
  const [search, setsearch] = useState('')
  const [selectedTemplate, setSelectedTemplate] = useState(null)

  const { data: templates }: any = useQuery(
    ['GET_ORDER_TEMPLATES', search],
    async () => {
      const payload = {
        search: search,
      }
      return await getOrderTemplate(payload)
    }
  )

  const debounced = debounce(async (value) => {
    setsearch(value)
  }, 500)

  const onSearch = (e) => {
    debounced(e.target.value)
  }

  return (
    <Modal
      className="modal-load-template-container"
      open={props.visible}
      onCancel={props.onClose}
      footer={false}
    >
      <p className="title">Load Template</p>
      <p className="sub-title">Select an existing template</p>
      <Input
        className="select-input"
        size="large"
        placeholder="Search"
        allowClear
        onInput={onSearch}
        suffix={<SearchOutlined />}
      />
      <div className="template-container">
        {orderBy(templates, ['created_date'], ['desc'])?.map(
          (item: any, index) => {
            return (
              <p
                key={index}
                className={cx(
                  selectedTemplate?.id === item?.id
                    ? 'selected-template-item'
                    : '',
                  'template-item'
                )}
                onClick={() => setSelectedTemplate(item)}
              >
                {item.name}
              </p>
            )
          }
        )}
      </div>
      <Row className="button-container">
        <Button onClick={props.onClose} size="large" className="cancel-button">
          Cancel
        </Button>
        <Button
          size="large"
          type="primary"
          onClick={() => props.onApply(selectedTemplate)}
        >
          Apply
        </Button>
      </Row>
    </Modal>
  )
}

export default LoadOrderTemplate
